module.exports = __webpack_public_path__ + "img/banner_excel.9c506f0e.png";